import validate from "E:/Websites/RRnuxt1/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "E:/Websites/RRnuxt1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("E:/Websites/RRnuxt1/middleware/auth.js"),
  "restrict-user": () => import("E:/Websites/RRnuxt1/middleware/restrict-user.js")
}